import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Star, User } from 'lucide-react';
import "../../../../assets/css/screens/customer/dashboard/mybookings/RateReviews.css";
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';

const RateReviews = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const booking = location.state;
  
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [review, setReview] = useState('');

  const handleSubmit = () => {
    if (rating === 0) {
      alert('Please select a rating');
      return;
    }

    console.log('Submitting review:', {
      bookingId: booking?.id,
      provider: booking?.provider,
      rating,
      review
    });

    // Add your API call here to submit the review
    // After successful submission:
    alert('Review submitted successfully!');
    navigate(-1);
  };

  if (!booking) {
    return (
      <div className="rr-page">
        <div className="rr-header">
          <button className="rr-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20}/>
          </button>
          <h1 className="rr-title">Rate & Review</h1>
        </div>
        <p style={{padding:'24px', textAlign:'center', opacity:0.5}}>
          Booking not found.
        </p>
      </div>
    );
  }

  return (
    <>
    <AppNavbar/>
    <div className="rr-page">
      
      {/* Header */}
      <div className="rr-header">
        <button className="rr-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={20}/>
        </button>
        <h1 className="rr-title">Rate & Review</h1>
      </div>

      {/* Content */}
      <div className="rr-content">
        
        {/* Provider Info */}
        <div className="rr-provider">
          <div className="rr-provider-icon">
            {booking.providerIcon || <User size={32} />}
          </div>
          <h2 className="rr-provider-name">{booking.provider}</h2>
          <p className="rr-service-name">{booking.service}</p>
        </div>

        {/* Rating Stars */}
        <div className="rr-rating-section">
          <p className="rr-rating-label">Tap to rate</p>
          <div className="rr-stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                className="rr-star-btn"
                onMouseEnter={() => setHoveredRating(star)}
                onMouseLeave={() => setHoveredRating(0)}
                onClick={() => setRating(star)}
              >
                <Star
                  size={40}
                  fill={(hoveredRating || rating) >= star ? '#fbbf24' : 'none'}
                  color={(hoveredRating || rating) >= star ? '#fbbf24' : '#e5e7eb'}
                  strokeWidth={2}
                />
              </button>
            ))}
          </div>
        </div>

        {/* Review Text */}
        <div className="rr-review-section">
          <textarea
            className="rr-textarea"
            placeholder="Share your experience (optional)..."
            value={review}
            onChange={(e) => setReview(e.target.value)}
            rows={4}
          />
        </div>

        {/* Submit Button */}
        <button className="rr-submit-btn" onClick={handleSubmit}>
          Submit Review
        </button>

      </div>

    </div>
    </>
  );
};

export default RateReviews;